import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { sleep } from 'src/utils/common';

/**
 * 검색의 정렬기준이 되는 url을 관리한다.
 */
const useSearchSortKey = (defaultSortKey?: string) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentSortKey = searchParams.get('sort') ?? defaultSortKey;

  const onChangeSortKey = useCallback(
    (sortKey: string) => {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set('sort', sortKey);
      setSearchParams(newSearchParams, { replace: true });
      sleep(100).then(() => window.scrollTo({ top: 0 }));
    },
    [searchParams, setSearchParams]
  );

  return {
    currentSortKey,
    onChangeSortKey,
  };
};

export default useSearchSortKey;
